import { render, staticRenderFns } from "./KycDocuments.vue?vue&type=template&id=63c1fce2&scoped=true&"
import script from "./KycDocuments.vue?vue&type=script&lang=js&"
export * from "./KycDocuments.vue?vue&type=script&lang=js&"
import style0 from "./KycDocuments.vue?vue&type=style&index=0&id=63c1fce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1fce2",
  null
  
)

export default component.exports